import { PrinterOutlined,DownloadOutlined } from "@ant-design/icons";
import React, { useState, useEffect,useRef } from "react";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import { PageHeader,Row,Col,Form,DatePicker,Select,Button,Input } from "antd";
import { useParams } from "react-router-dom";
import commonService from "../../api/common.service";
import { DATE_FORMAT_DMY_HYPHEN,SUCCESS_STATUS } from "../../utility/Constants";
import commonUtility from "../../utility/Utils";
import { PRINT_BASE_URL } from "../../utility/URL";

const { Option } = Select;

const TransactionalReport = () => {
    const params = useParams();
    const [form] = Form.useForm();

    const [selectedFromDate, setSelectedFromDate] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState("");   
    const buttonref = useRef(null);

    const onFromDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedFromDate(dateString)
        form.setFieldsValue({
            from_date : dateString
        });
    };

    const onEndDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedEndDate(dateString)
        form.setFieldsValue({
            to_date : dateString
        });
        
    };
    // const onTypeChange = (id, object) => {
    //     form.setFieldsValue({
    //         type : dateString
    //     });
    // }

    const onPostClick = async () => {
      
        const values = await form.validateFields();      
        const url = `${PRINT_BASE_URL}`+'otherreport/printpdf/'+values.from_date+'/'+values.to_date+'/'+values.type+'/'+1; 
        commonUtility.openInNewTab(url);  
      };

      const handleExcelButtonClick = async () => {
        try {
            // Submit form data
            const values = await form.validateFields();
            const url = `${PRINT_BASE_URL}`+'otherreport/excel/'+values.from_date+'/'+values.to_date+'/'+values.type+'/'+1; 
            commonUtility.openInNewTab(url);

        } catch (error) {
            console.error('Error:', error);
        }
    };

    function disabledDate(current) {

        let sessionData = commonUtility.getLoggedInUserInfo();

        //console.log(sessionData.yearData.year);
        // Range of allowed dates        
        const startDate = new Date(sessionData.yearData.start_date); // Example start date
        const endDate = new Date(sessionData.yearData.end_date);   // Example end date

        // added 1 day to endDate as it is exclude while comparing (i.e March 31 is not selecting)
        endDate.setDate(endDate.getDate() + 1);

        // Return true if the date is not within the range
        return current < startDate || current > endDate;
    }
           

    return (
        <>
            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Transactional Report"
                        subTitle=""

                    ></PageHeader>
                    <div className="form-content" style={{
                        background: '#f7f7f7',
                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                    }}>

                        <Row className="" style={{ background: "transparent" }}>
                            <Col className="" xs={24} xl={24}>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onPostClick}
                                    autoComplete="off"
                                // initialValues={formDefaultValues}
                                >

                                    <Row gutter={20} >

                                        <Col xs={24} xl={5} >

                                            <Form.Item name="from_date_picker" label="From Date" rules={[
                                                {
                                                    required: true,
                                                    message: 'Start date is required',
                                                },
                                            ]}>
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_HYPHEN}
                                                    onChange={onFromDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    disabledDate={disabledDate}
                                                />
                                            </Form.Item>
                                            <Form.Item name="from_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={5} >

                                            <Form.Item name="to_date_picker" label="End Date" rules={[
                                                {
                                                    required: true,
                                                    message: 'End date is required',
                                                },
                                            ]}>
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_HYPHEN}
                                                    onChange={onEndDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    disabledDate={disabledDate}
                                                />
                                            </Form.Item>
                                            <Form.Item name="to_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                       
                                        </Col>
                                      
                                        <Col xs={24} xl={8} >
                                            <Form.Item name="type" label="Type"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Type is required',
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left" 
                                                    showSearch
                                                    // onSelect={(value, event) =>onTypeChange(value, event) }
                                                    placeholder="Search to Select"
                                                    placement="bottomLeft"
                                                    allowClear={true}
                                                    defaultValue=""
                                                >
                                                    <Option key="" value="">Select</Option>
                                                    <Option key="B2B" value="B2B">B2B</Option>
                                                    <Option key="B2C" value="B2C">B2C</Option>
                                                    <Option key="BR" value="BR">Bill Register</Option>
                                                    <Option key="HSN" value="HSN">HSN Summary</Option>
                                                   
                                                </Select>
                                            </Form.Item>
                                        </Col>


                                        <Col xs={24} xl={2}>
                                            <Form.Item label=" ">                                               
                                                <Button
                                                    htmlType="submit"
                                                    shape="round"
                                                    className="custom-button-green"
                                                >
                                                    <PrinterOutlined /> Print
                                                </Button>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={1}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="button"
                                                    shape="round"
                                                    className="custom-button-green"
                                                    onClick={handleExcelButtonClick}
                                                >
                                                    <DownloadOutlined /> Excel
                                                </Button>
                                            </Form.Item>
                                        </Col>





                                    </Row>
                                </Form>



                            </Col>
                        </Row>
                    </div>

                </div>
            </div>
        </>
    )

}

export default TransactionalReport;
